import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { db, FirebaseTimestamp } from 'firebase/index'
import { push } from 'connected-react-router'

const deleteTag = (id: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    return db
      .collection('tags')
      .doc(id)
      .update({ is_deleted: true, updated_at: FirebaseTimestamp.now() })
      .then(() => {
        dispatch(hideLoadingAction())
        dispatch(push('/admin/master/tags'))
      })
      .catch((error) => {
        console.error(error)
        dispatch(hideLoadingAction())
      })
  }
}

export default deleteTag
